import { render, staticRenderFns } from "./CustomerSearch.vue?vue&type=template&id=3153dda0&scoped=true"
import script from "./CustomerSearch.vue?vue&type=script&lang=js"
export * from "./CustomerSearch.vue?vue&type=script&lang=js"
import style0 from "./CustomerSearch.vue?vue&type=style&index=0&id=3153dda0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3153dda0",
  null
  
)

export default component.exports